import config from '../../../../../../config';

const {
  webAppURL,
  instagram: { clientId, scope },
} = config;

/**
 * Generates Instagram OAuth authorization URL with the specified scope
 * @param {string} authScope - The scope for Instagram authorization
 * @returns {string} Complete Instagram OAuth authorization URL
 */
export const getInstagramAuthUrl = (authScope = scope, isSecondary = false, coachId = '') => `
    https://www.instagram.com/oauth/authorize
    ?client_id=${clientId}
    &redirect_uri=${webAppURL}/auth/instagram-callback
    &scope=${authScope}
    &response_type=code
    ${isSecondary ? `&state=secondary:${coachId}` : ''}`.replace(/\s+/g, '');
